import React from "react";
import { graphql } from "gatsby";
import { PostPage as PageWrapper } from "../../components/Page";
import { VideoDetails } from "../../ng-components/Video/VideoDetails";
import {
    massageGhostVideosData,
    massageGhostVideoData,
} from "../../gatsbyGhostNoissue";

const VideoPost = ({
    data: { video: rawVideoData, post, relatedVideos },
    location,
    pageContext: { channelSlug, channelName },
}) => {
    const theme = {
        contrastTextColor: "#2748F3",
    };

    const related = {
        channel: {
            slug: channelSlug,
            name: channelName,
        },
        videos: massageGhostVideosData(relatedVideos),
    };
    const video = massageGhostVideoData(rawVideoData);
    return (
        <PageWrapper theme={theme} data={post} location={location}>
            <VideoDetails video={video} related={related} />
        </PageWrapper>
    );
};

export default VideoPost;

// Corresponding post link
// is Eco Alliance bool
// tags
export const query = graphql`
    query noissuetvVideo(
        $slug: String!
        $postSlug: String!
        $channelSlug: String!
    ) {
        post: ghostPost(slug: { eq: $postSlug }) {
            ...GhostPostFields
        }
        video: contentfulVideo(slug: { eq: $slug }) {
            slug
            title
            url
            postSlug
            excerpt {
                excerpt
            }
            originalPublishedDate
            createdAt
        }
        relatedVideos: allContentfulVideo(
            sort: { fields: originalPublishedDate, order: DESC }
            filter: {
                node_locale: { eq: "en-US" }
                slug: { ne: $slug }
                channel: { slug: { eq: $channelSlug } }
            }
            limit: 6
            skip: 0
        ) {
            nodes {
                id
                title
                slug
                excerpt {
                    excerpt
                }
                url
                originalPublishedDate
                createdAt
                type {
                    id: contentful_id
                }
                channel {
                    slug
                    name
                }
                community {
                    id: contentful_id
                }
            }
        }
    }
`;
